var _a, _b;
import { __assign } from "tslib";
import { handleActions } from 'redux-actions';
import { requestEarningsCalculation, requestEarningsCalculationSuccess, requestEarningsCalculationError, } from './actionCreators';
import { reduxKey } from './constants';
var handler = handleActions((_a = {},
    _a[requestEarningsCalculation.toString()] = function (state) { return (__assign(__assign({}, state), { isBusy: true, isError: false, errorMsg: undefined, result: undefined })); },
    _a[requestEarningsCalculationSuccess.toString()] = function (state, action) { return (__assign(__assign({}, state), { isBusy: false, isError: false, errorMsg: undefined, result: action.payload })); },
    _a[requestEarningsCalculationError.toString()] = function (state, action) { return (__assign(__assign({}, state), { isBusy: false, isError: true, errorMsg: action.payload, result: undefined })); },
    _a), {
    isBusy: false,
    isError: false,
    errorMsg: undefined,
    result: undefined,
});
export default (_b = {},
    _b[reduxKey] = handler,
    _b);
//# sourceMappingURL=reducers.js.map